import { Helmet } from "react-helmet";

interface SeoControlProps {
  noindex?: boolean;
  nofollow?: boolean;
}

const SeoControl = ({ noindex, nofollow }: SeoControlProps) => {
  // Only production is allowed to be indexed/followed. All other
  // environments are forced to noindex,nofollow and cannot be overridden.
  const isProduction = process.env.REACT_APP_ENV === "production";

  const rules = [
    !isProduction || noindex ? "noindex" : "index",
    !isProduction || nofollow ? "nofollow" : "follow",
  ]
    .filter(Boolean)
    .join(",");

  if (!rules) return null;

  return (
    <Helmet>
      <meta name="robots" content="noimageindex" />
      <meta name="robots" content={rules} />
    </Helmet>
  );
};

export default SeoControl;
